export default __webpack_public_path__ + "static/media/logo_white.f90846df.png";